export const headerList = [
  {
    label: 'Symbol',
    key: 'symbol',
  },
  {
    label: 'Action',
    key: 'action'
  },
  {
    label: 'Qty.',
    key: 'quantity'
  },
  {
    label: 'Fill',
    key: 'fillPrice' 
  },
  {
    label: 'Total Cost',
    key: 'totalCost'
  },
  {
    label: 'Time',
    key: 'executionTime'
  },
  {
    label: 'Quote',
    key: 'quoteAtTimeOfOrder'
  },
  {
    label: 'Underlying',
    key: 'underlyingQuoteAtTimeOfFill'
  },
  {
    label: 'Commission',
    key: 'commission'
  },
  {
    label: 'Details',
    key: 'reason'
  },
];

/* 
	"execution": {
		"symbol": "AMD211029C00124000",
		"action": "buy",
		"quantity": 10.0,
		"tradingSystemId": "BASIC_TRADING_SYSTEM1635336819963",
		"tradePlanId": 1635353082267,
		"fillPrice": 2.11,
		"accountId": "BACKTEST",
		"totalCost": 2110.0,
		"commission": 0,
		"executionTime": "2021-10-27T12:44:50.000-0400",
		"quoteAtTimeOfOrder": "bid: 2.08 ask: 2.11",
		"underlyingQuoteAtTimeOfFill": "bid: 123.59 ask: 123.64",
		"reason": "BTO|MARKET_ORDER"
	}
}

*/
